import React from 'react'

const PageNotFound = ({message}) => {
  return (
    <div>{message}</div>
  )
}

export default PageNotFound